import React from 'react';
import { 
  ShieldCheck, Download, Calendar, RefreshCcw, FileText, 
  Award, Info, AlertTriangle, CheckCircle2, Gavel, 
  Globe, Fingerprint, Activity, BookOpen 
} from 'lucide-react';

import QRCode from 'qrcode'; // Import the library

import html2canvas from 'html2canvas';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import autoTable from "jspdf-autotable";
import LOGO_BASE64 from "../Images/EvalLogo.png"

const CertificatePage = ({ profile, currentUser, stats }) => {
  
  // Use the shared data for the legal identity logic


  const handleDownload = () => {
    // Use a prefix + a sliced UID for a professional serial number look
  
    console.log("Current User from DB:", currentUser);
    const shortUid = currentUser.uid.slice(0, 8).toUpperCase();
    
    const authData = {
      userName: profile.fullName,
      companyName: profile.organizationName,
      // This ID is now PERMANENT for this user
      certId: `FNI-EVL-${shortUid}` 
    };
  
    handleExportCertification(authData);
  };
  
  
  
  const handleExportCertification = async (authData ={}) => {
  // 1. Extract the UID first to build the CertID
    const uid = authData?.uid || "";
  
    // 2. Destructure with "Double Fallbacks"
    const { 
      // Permanent ID based on UID
      certId = uid 
        ? `FNI-EVL-${uid.slice(0, 8).toUpperCase()}` 
        : `FNI-EVL-TEMP-${Date.now().toString().slice(-4)}`,
      
      // Check both 'userName' (passed in) and 'fullName' (from DB object)
      userName = authData?.userName || authData?.fullName || "AUTHORIZED_INSPECTOR", 
      
      // Check both 'companyName' and 'organizationName'
      companyName = authData?.companyName || authData?.organizationName || "OFFICIAL_PARTNER_NDT",
      
      subscriptionEndDate = authData?.subscriptionEndDate || null 
    } = authData;
  
    // Debugging: See exactly what the function "sees"
    console.log("PDF Generation Data:", { certId, userName, companyName });
  
    const doc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
  
  
    // You can encode just the ID, or a full verification URL
    const validationUrl = `https://focusndtgroup.com/verify?id=${certId}`;
    let qrBase64;
    
    try {
      qrBase64 = await QRCode.toDataURL(validationUrl, {
        margin: 1,
        width: 200,
        color: {
          dark: '#022C50', // Match your headerBlue [2, 44, 80]
          light: '#FFFFFF'
        }
      });
    } catch (err) {
      console.error("QR Generation Error:", err);
    }
    
    // Date Logic
    const now = new Date();
    const issueDate = now.toLocaleDateString('en-GB');
    const expireDate = subscriptionEndDate 
      ? new Date(subscriptionEndDate).toLocaleDateString('en-GB')
      : new Date(now.setFullYear(now.getFullYear() + 1)).toLocaleDateString('en-GB');
  
    const colors = {
      evalBlue: [7, 89, 133],
      slate900: [15, 23, 42],    // "Deep Ink" Black
      slate500: [100, 116, 139],
      legalRed: [185, 28, 28],   // Compliance Red
      border: [203, 213, 225],   // Subtle Steel Gray
      bgSlate: [248, 250, 252],  // Ultra-light grey for tables
       greenDark: [0, 100, 0],   // Deep Forest Green (Text/Borders)
     greenMain: [46, 139, 87],
    };
  
    // 1. SECURITY WATERMARK (Micro-Text & Geometric)
  // HIGH-SECURITY GUILLOCHÉ WATERMARK
  doc.setDrawColor(242, 245, 248);
  doc.setLineWidth(0.05);
  
  for (let i = 0; i < 300; i += 20) {
    for (let x = 0; x < 210; x += 2) {
      // Mathematical Sine Wave to prevent digital reconstruction
      const y1 = i + Math.sin(x * 0.15) * 4;
      const y2 = i + Math.sin((x + 2) * 0.15) * 4;
      doc.line(x, y1, x + 2, y2);
    }
  }
  
    // 2. PRIMARY FRAME
    doc.setDrawColor(...colors.slate900);
    doc.setLineWidth(0.5);
    doc.rect(10, 10, 190, 277);
  
    // 3. TOP AUTHORITY HEADER (Global Standard)
    doc.setFillColor(...colors.slate900);
    doc.rect(10, 10, 190, 12, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.text("FOCUS NDT INNOVATIONS | INDUSTRIAL COMPLIANCE & VALIDATION OFFICE", 15, 17.5);
    doc.text(`CERTIFICATE REF: ${certId}`, 195, 17.5, { align: "right" });
  
    // 4. BRANDING & LOGO (High Position)
  // --- HEADER CONFIGURATION (Logo Left | Title Center) ---
    
    const leftX = 10;        // Left Anchor for Logo
    const centerX = 105;     // Absolute Center for A4 (210/2)
    const headerY = 22;   
     const logoY = 15;   // Vertical Start Point
  
    // 1. PRIMARY LOGO (Top-Left Anchor)
    const logoWidth = 48; 
    try {
      // If using a base64 variable, ensure it's not null/undefined
      if (typeof LOGO_BASE64 !== 'undefined' && LOGO_BASE64) {
        doc.addImage(LOGO_BASE64, 'PNG', leftX, logoY, logoWidth, 0, undefined, 'FAST');
      }
    } catch (e) {
      console.error("Logo Display Error:", e);
    }
  
    // 2. BRANDING TITLE (Perfectly Centered)
    // We place this slightly lower than the logo top for visual balance
    const titleY = headerY + 12; 
  
    doc.setTextColor(...colors.evalBlue);
    doc.setFontSize(32); 
    doc.setFont("helvetica", "bold");
    doc.text("EvalNDT™", centerX, titleY, { align: "center" }); 
    
    // Underline (Centered relative to text)
    const lineWeight = 40;
    doc.setDrawColor(...colors.evalBlue);
    doc.setLineWidth(1.0);
    doc.line(centerX - (lineWeight/2), titleY + 3, centerX + (lineWeight/2), titleY + 3); 
  
    // 3. SUB-TEXT (Centered)
    doc.setTextColor(...colors.slate900);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Industrial Data Synthesis Engine for Advanced Ultrasonics", centerX, titleY + 10, { align: "center" });
    
    // 4. METADATA (Centered)
    doc.setFontSize(7);
    doc.setTextColor(...colors.slate500);
    const buildInfo = `VALIDATED CORE BUILD: 4.0.2-SECURE | HASH: ${certId.split('-')[2]}`;
    doc.text(buildInfo, centerX, titleY + 15, { align: "center" });
  
    // 5. SEPARATOR LINE (Full Width)
    doc.setDrawColor(...colors.border);
    doc.setLineWidth(0.2);
    doc.line(leftX, titleY + 22, 195, titleY + 22);
    // 5. DOCUMENT TITLE
    doc.setFontSize(18);
    doc.setTextColor(...colors.slate900);
    doc.setFont("times", "bold");
    doc.text("STATEMENT OF SOFTWARE CONFORMITY", 105, 75, { align: "center" });
  
    // 6. TECHNICAL DATA GRID (Heavy Duty Table)
    const tableY = 85;
    doc.setDrawColor(...colors.slate900);
    doc.setLineWidth(0.3);
    doc.setFillColor(...colors.bgSlate);
    doc.rect(15, tableY, 180, 8, 'F'); 
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.5);
    doc.text("OFFICIAL SYSTEM DISCLOSURE & LICENSEE DATA", 20, tableY + 5.5);
  
    const specRows = [
      ["Registered Licensee", companyName.toUpperCase()],
      ["Authorized Inspector", userName.toUpperCase()],
      ["Core Architecture", "EvalNDT™ Industrial Release v4.0.2"],
      ["Primary Methodology", "PAUT / TOFD / Conventional UT"],
      ["Standard Compliance", "ASME BPVC Sec V Art 4 | ISO 17640"],
      ["Date of Validation", issueDate],
      ["Expiration Date", expireDate]
    ];
  
    specRows.forEach((row, i) => {
      const y = tableY + 8 + ((i + 1) * 9);
      doc.setDrawColor(...colors.border);
      doc.rect(15, y - 6, 180, 9);
      doc.setFont("helvetica", "bold");
      doc.text(row[0], 20, y);
      doc.setFont("helvetica", "normal");
      if(row[0] === "Expiration Date") {
          doc.setTextColor(...colors.legalRed);
          doc.setFont("helvetica", "bold");
      }
      doc.text(row[1], 85, y);
      doc.setTextColor(...colors.slate900);
    });
  
    // 7. STATUTORY LIMITATION BOX (Red Shield Design)
    const boxY = 175;
    doc.setFillColor(255, 252, 252); 
    doc.rect(15, boxY, 180, 38, 'F');
    doc.setDrawColor(...colors.legalRed);
    doc.setLineWidth(0.5);
    doc.rect(15, boxY, 180, 38, 'S');
  
    doc.setTextColor(...colors.legalRed);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.text("MANDATORY REGULATORY OVERSIGHT & LIMITATION", 105, boxY + 8, { align: "center" });
  
    doc.setTextColor(...colors.slate900);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    const legalText = "EvalNDT™ serves as an algorithmic computational aid. In accordance with PCN, ASNT, and ISO 9712 protocols, software-generated findings are not final inspection conclusions. This document is valid only when output is manually audited and signed-off by a certified Level II or Level III professional. Focus NDT Innovations holds no liability for structural integrity decisions made without formal human verification.";
    const splitLegal = doc.splitTextToSize(legalText, 170);
    doc.text(splitLegal, 105, boxY + 16, { align: "center", lineHeightFactor: 1.3 });
  
  // 8. SIGNATORIES & DIGITAL GOLDEN SECURITY STAMP
  // 8. SIGNATORIES & SOLID GOLDEN SECURITY STAMP
  // 8. SIGNATORIES & COMPACT GOLDEN SECURITY STAMP
   // 8. SIGNATORIES & PRECISION QR-ENCODED SEAL
    const sigY = 250;
    const sealX = 105; 
    const sealY = sigY - 12;
  
    const goldDark = [153, 101, 21];  
    const goldMain = [184, 134, 11]; 
    const blueMain = [0, 102, 204];
    const blueDark = [0, 32, 96];   // Deep Navy (Legal/Official)
  
    // --- STEP 1: THE QR-DNA FILL (Internal Texture) ---
    const seedStr = certId || "EVAL-NDT-PRO";
    doc.setLineWidth(0.1);
    
    for (let x = -10.5; x <= 10.5; x += 1.5) {
      for (let y = -10.5; y <= 10.5; y += 1.5) {
        // Draw only within the inner safety radius
        if (Math.sqrt(x*x + y*y) < 11.5) {
          const charIdx = Math.abs((x + y) % seedStr.length);
          const val = seedStr.charCodeAt(Math.floor(charIdx));
          
          doc.setFillColor(...(val % 2 === 0 ? blueMain : blueDark));
          
          if (val % 3 === 0) {
            doc.rect(sealX + x - 0.4, sealY + y - 0.4, 0.8, 0.8, 'F'); 
          } else {
            doc.circle(sealX + x, sealY + y, 0.45, 'F'); 
          }
        }
      }
    }
  
    // --- STEP 2: REINFORCED TRIPLE-WALL BORDER ---
    // This replaces the sun-like lines with a solid, high-precision frame
    doc.setDrawColor(...blueDark);
    
    // Outer Thick Wall (The anchor)
    doc.setLineWidth(1.2);
    doc.circle(sealX, sealY, 14.5, 'S');
  
    // Middle Guard Line (The gap)
    doc.setLineWidth(0.2);
    doc.circle(sealX, sealY, 13.0, 'S');
  
    // Inner Security Ring (Encloses the QR fill)
    doc.setLineWidth(0.6);
    doc.circle(sealX, sealY, 12.0, 'S');
  
    // --- STEP 3: LOGO "LENS" (Pure Center) ---
   // --- STEP 3: BRANDING CENTER ---
    doc.setFillColor(255, 255, 255);
    doc.circle(sealX, sealY, 7, 'F'); // Slightly larger white lens
    
    doc.setDrawColor(...blueDark);
    doc.setLineWidth(0.3);
    doc.circle(sealX, sealY, 7, 'S');
  
    // Option A: If you have the EvalNDT Logo Image
  
        doc.setTextColor(...blueDark);
        doc.setFont("helvetica", "bold");
        
        // Main Brand Name
        doc.setFontSize(5);
        doc.text("EVALNDT", sealX - 1.5, sealY - 0.5, { align: "center", charSpace: 0.5 });
        
        // Sub-brand / Division
        doc.setFont("helvetica", "normal");
        doc.setFontSize(3.5);
        doc.text("INNOVATIONS", sealX - 1.5, sealY + 2.5, { align: "center", charSpace: 0.3 });
        
        // Center Divider Line (Very Professional)
        doc.setLineWidth(0.15);
        doc.line(sealX - 4, sealY + 0.5, sealX + 4, sealY + 0.5);
    
  
    // --- STEP 4: CLEAN SIGNATURE BLOCK ---
    doc.setDrawColor(...colors.slate900);
    doc.setLineWidth(0.5);
    // Left: Sanjay More | Right: Omkar More
    doc.line(25, sigY, 85, sigY);
    doc.line(125, sigY, 185, sigY);
  
  // --- SIGNATURE BLOCK (AUTHENTIC STYLE) ---
    const sigLineY = 250;
    const sigTextY = sigLineY - 4; // Positioned for slight line overlap
    const penInk = [0, 43, 128];   // Professional Ballpoint Navy Blue
  
    // 1. SIGNATURE LINES
    doc.setDrawColor(40, 40, 40);
    doc.setLineWidth(0.4);
    doc.line(25, sigLineY, 85, sigLineY);
    doc.line(125, sigLineY, 185, sigLineY);
  
    // 2. "FAUX-ORIGINAL" SCRIPT SIGNATURES
    doc.setTextColor(...penInk);
    
    // Sanjay More - Classic Script Style
    doc.setFont("times", "italic"); 
    doc.setFontSize(16);
    doc.text("Sanjay More", 55, sigTextY, { align: "center", angle: -1.5 });
  
    // Omkar More - Technical Script Style
    doc.setFont("times", "italic");
    doc.setFontSize(15);
    doc.text("Omkar More", 155, sigTextY, { align: "center", angle: 1.2 });
  
    // 3. PRINTED CREDENTIALS (Symmetrical Alignment)
    doc.setTextColor(20, 20, 20);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9.5);
    doc.text("SANJAY MORE", 55, sigLineY + 5, { align: "center" });
    doc.text("OMKAR MORE", 155, sigLineY + 5, { align: "center" });
  
    // Designations
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.5);
    doc.text("CEO | Focus NDT Innovations", 55, sigLineY + 9, { align: "center" });
    doc.text("CTO | Focus NDT Innovations", 155, sigLineY + 9, { align: "center" });
    
    // Certifications & Qualifications
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text("NDT LEVEL III (UT, MT, PT)", 55, sigLineY + 13, { align: "center" });
    doc.text("IT ENGINEER | PCN LEVEL II (PAUT)", 155, sigLineY + 13, { align: "center" });
  
    // 9. QR SECURITY BOX
    const qrX = 173;
    const qrY = 28;
    const qrSize = 22;
  
    if (qrBase64) {
      // Add the generated unique QR code
      doc.addImage(qrBase64, 'PNG', qrX, qrY, qrSize, qrSize, undefined, 'FAST');
    }
  
    // Outline for the QR box to maintain the "Legal" look
    doc.setDrawColor(...colors.slate900);
    doc.setLineWidth(0.4);
    doc.rect(qrX, qrY, qrSize, qrSize); 
    
    doc.setFontSize(6);
    doc.setTextColor(...colors.slate900);
    doc.text("SECURE SCAN", qrX + (qrSize / 2), qrY + qrSize + 3, { align: "center" });
  
    // 10. LEGAL FOOTER (High Alignment)
    doc.setFontSize(6.5);
    doc.setTextColor(...colors.slate500);
    const footerLegal = `AUTHENTICITY NOTICE: This certificate is a digitally protected asset of Focus NDT Innovations. Any unauthorized duplication or tampering with the security hash [${certId}] is a breach of industrial protocol. Verification services are hosted exclusively at focusndtgroup.com. Build Architecture: 4.0.2-Stable.`;
    const splitFooter = doc.splitTextToSize(footerLegal, 175);
    doc.text(splitFooter, 105, 282, { align: "center", lineHeightFactor: 1.1 });
  
    // 11. INVISIBLE PDF ENCRYPTION METADATA
    doc.setProperties({
      title: `Conformity_Statement_${certId}`,
      author: 'Focus NDT Innovations',
      subject: 'Software Validation Certificate',
      keywords: 'NDT, EvalNDT, Compliance, ASME, ISO',
      creator: 'EvalNDT™ Digital Core'
    });
  
    doc.save(`EvalNDT_Conformity_${certId}.pdf`);
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      
      {/* --- TOP LEGAL BAR --- */}
      <div className="bg-slate-900 px-8 py-2 flex justify-between items-center text-[9px] font-mono text-slate-400 uppercase tracking-[0.2em]">
        <div className="flex gap-6">
          <span className="flex items-center gap-1.5"><Globe size={10} /> Compliance: ISO 9712 / ASNT</span>
          <span className="flex items-center gap-1.5"><Fingerprint size={10} /> Auth Hash: {currentUser?.uid?.slice(0,12)}</span>
        </div>
        <div className="hidden md:block">
          Autonomous Reporting Engine v4.0.2 // EvalNDT System
        </div>
      </div>

      {/* --- HERO HEADER --- */}
      <div className="bg-white border-b border-slate-200 px-10 py-14">
        <div className="max-w-[1600px] mx-auto flex flex-col xl:flex-row justify-between items-start xl:items-center gap-10">
          <div className="space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-50 border border-blue-100 rounded-full">
              <ShieldCheck className="text-blue-600" size={14} />
              <span className="text-[10px] font-black text-blue-700 uppercase tracking-widest">Master Validation Registry</span>
            </div>
            <h1 className="text-5xl font-serif font-black text-slate-900 uppercase tracking-tighter leading-none">
              Certificate of Operational <br /> <span className="text-blue-900">Competence</span>
            </h1>
            <p className="max-w-2xl text-slate-500 font-medium leading-relaxed">
              Formal evidence of high-precision signal analysis capabilities for {profile?.fullName || "Authorized Personnel"}.
            </p>
          </div>

          <button 
            onClick={handleDownload}
            className="flex items-center gap-6 bg-blue-900 hover:bg-black text-white px-10 py-6 shadow-2xl transition-all group"
          >
            <div className="text-left">
              <span className="block text-amber-400 text-sm font-black uppercase tracking-widest">Download Master PDF</span>
              <span className="block text-[9px] text-white/50 uppercase font-bold mt-0.5">High Resolution Print Ready</span>
            </div>
            <Download size={24} className="group-hover:translate-y-1 transition-transform" />
          </button>
        </div>
      </div>

      {/* --- CONTENT GRID --- */}
      <main className="max-w-[1600px] mx-auto w-full p-10 grid grid-cols-12 gap-10">
        
        {/* LEFT COLUMN */}
        <div className="col-span-12 xl:col-span-8 space-y-10">
          
          <section className="bg-white border border-slate-200 shadow-sm overflow-hidden">
            <div className="bg-slate-50 px-8 py-4 border-b border-slate-200 flex justify-between items-center">
              <h3 className="text-xs font-black text-slate-900 uppercase tracking-widest flex items-center gap-2">
                <Award size={16} className="text-blue-600" /> Official Credential Metadata
              </h3>
              <span className="text-[10px] font-mono text-slate-400">SYNC_STATUS: LIVE</span>
            </div>
            
            <div className="p-10 grid grid-cols-1 md:grid-cols-2 gap-y-12 gap-x-16">
              <div>
                <label className="block text-[10px] font-black text-slate-400 uppercase mb-2">Authorized Inspector</label>
                <p className="text-2xl font-bold text-slate-900">{profile?.fullName}</p>
                <p className="text-[10px] text-slate-400 font-bold mt-1 uppercase">PCN/ASNT Verified Professional</p>
              </div>
              <div>
                <label className="block text-[10px] font-black text-slate-400 uppercase mb-2">Organization</label>
                <p className="text-2xl font-bold text-slate-900">{profile?.organizationName}</p>
                <p className="text-[10px] text-slate-400 font-bold mt-1 uppercase">Primary Licensed Entity</p>
              </div>
              <div>
                <label className="block text-[10px] font-black text-slate-400 uppercase mb-2">Certificate Serial ID</label>
                <p className="text-2xl font-mono font-bold text-blue-800">
                  FNI-EVL-{currentUser?.uid?.slice(0, 8).toUpperCase() || "..."}
                </p>
                <p className="text-[10px] text-slate-400 font-bold mt-1 uppercase tracking-wider">Unique Digital Identity</p>
              </div>
              <div>
                <label className="block text-[10px] font-black text-slate-400 uppercase mb-2">Total Managed Logs</label>
                <p className="text-2xl font-bold text-slate-900">{stats?.monthly || 0} <span className="text-sm font-medium text-slate-400">this month</span></p>
                <p className="text-[10px] text-slate-400 font-bold mt-1 uppercase">Audit Activity Record</p>
              </div>
            </div>
          </section>

          {/* Educational Content */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white border border-slate-200 p-8">
              <Gavel className="text-blue-600 mb-6" size={20} />
              <h4 className="font-black text-slate-900 uppercase text-xs mb-4">Why is this important?</h4>
              <p className="text-[11px] text-slate-500 leading-relaxed">
                In NDT, accuracy is safety. This certificate acts as your <strong>legal record of competence</strong>, proving your reporting engine is operating within ISO calibrated tolerances.
              </p>
            </div>
            <div className="bg-white border border-slate-200 p-8">
              <BookOpen className="text-emerald-600 mb-6" size={20} />
              <h4 className="font-black text-slate-900 uppercase text-xs mb-4">How to use it?</h4>
              <p className="text-[11px] text-slate-500 leading-relaxed">
                Append your <strong>Certificate Serial ID</strong> to every PAUT/UT report. It allows third-party auditors to verify that the EvalNDT engine was used for the analysis.
              </p>
            </div>
            <div className="bg-white border border-slate-200 p-8">
              <Activity className="text-amber-600 mb-6" size={20} />
              <h4 className="font-black text-slate-900 uppercase text-xs mb-4">Quality Assurance</h4>
              <p className="text-[11px] text-slate-500 leading-relaxed">
                This engine provides a deterministic mathematical trail. Every defect detection can be traced back to the physics of the signal, ensuring full audit readiness.
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="col-span-12 xl:col-span-4 space-y-8">
          <div className="bg-white border-2 border-slate-900 p-8 shadow-[10px_10px_0px_0px_rgba(15,23,42,0.1)]">
            <div className="flex items-center justify-between mb-8">
              <h4 className="font-black text-slate-900 uppercase text-xs tracking-widest">Renewal Cycle</h4>
              <div className="px-2 py-1 bg-emerald-100 text-emerald-700 text-[8px] font-black uppercase rounded">Status: Active</div>
            </div>
            <div className="space-y-4 mb-8">
              <div className="flex justify-between border-b border-slate-100 pb-2">
                <span className="text-[10px] font-bold text-slate-400 uppercase">Valid For:</span>
                <span className="text-xs font-black text-slate-900 uppercase">365 Days</span>
              </div>
              <p className="text-[10px] text-slate-500 leading-relaxed italic">
                Re-validation is required annually to ensure sensor-to-software sync remains 100% accurate.
              </p>
            </div>
            <button className="w-full bg-slate-900 text-white font-black py-4 uppercase text-[10px] tracking-[0.2em] hover:bg-blue-900 transition-colors flex items-center justify-center gap-3">
              <RefreshCcw size={14} /> Begin Re-Validation
            </button>
          </div>

          <div className="bg-slate-50 border border-slate-200 p-8">
            <h4 className="font-black text-slate-900 uppercase text-[10px] mb-6">Renewal Requirements:</h4>
            <div className="space-y-4">
              {["Active Credits", "Level II/III Credentials", "Hardware Logs", "v4.0.2 Software"].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <CheckCircle2 size={14} className="text-emerald-500" />
                  <span className="text-[10px] font-bold text-slate-600 uppercase">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-red-50 border-l-4 border-red-500 p-6">
            <div className="flex gap-4">
              <AlertTriangle className="text-red-600" size={20} />
              <div>
                <h5 className="text-[10px] font-black text-red-900 uppercase">Audit Warning</h5>
                <p className="text-[9px] text-red-700/80 font-bold uppercase mt-1">
                  Expired certificates are legally inadmissible. Please renew 30 days prior to expiration.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CertificatePage;